import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { apiClient } from "@/api";
import { Project } from "@/api/types";
import EditableProject from "@/components/projects/editing/EditableProject";
import SimplePage from "@/components/structure/SimplePage";

import editProjectHelp from "@/assets/helpdocs/create-task.md"  with { type: "text" };

export default function EditProject() {
  const { projectId } = useParams<{ projectId: string }>();
  const [project, setProject] = useState<Project | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProject() {
      try {
        setLoading(true);
        const data = await apiClient.get<Project>(`/projects/${projectId}/`);
        setProject(data);
      } catch (err) {
        setError("Failed to fetch project details");
        console.error("Error fetching project:", err);
      } finally {
        setLoading(false);
      }
    }

    if (projectId) {
      fetchProject();
    }
  }, [projectId]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">Loading project...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-red-500 text-center">{error}</div>
        </div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">Project not found</div>
        </div>
      </div>
    );
  }

  return (
    <SimplePage title={`Edit Project: ${project.name}`} helpTitle="Editing Projects" helpContent={editProjectHelp}>
        <div className="mb-8">
          <a href={`/projects/${project.id}`} className="text-blue-600 hover:underline ml-2">
          ← Return to Project
          </a>
        </div>
          
        <EditableProject project={project} />
    </SimplePage>
  );
}
